import React from "react";
import Helmet from "react-helmet";


import favicon from "../../static/favicon.png"

export function Head() {
    return (
        <Helmet
            title="Lower North Shore Greens"
            meta={[
                { name: 'description', content: 'Lower North Shore Greens' },
                { name: 'keywords', content: 'greens,nsw,politics,nswpol,auspol' },
            ]}
            link={[
                { rel: 'shortcut icon', type: 'image/png', href: `${favicon}` }
            ]}
        />
    )
}